var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconofmodal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185061",
    "data-name": "Group 185061",
    transform: "translate(-947 -256)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1971",
    "data-name": "Ellipse 1971",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(947 256)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_2976286",
    transform: "translate(956 263.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close_1_",
    transform: "translate(0.001 1.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63169",
    "data-name": "Path 63169",
    d: "M1.14,14.448a1.132,1.132,0,0,1-.809-.276,1.159,1.159,0,0,1,0-1.622L10,2.781a1.131,1.131,0,0,1,1.61.054,1.159,1.159,0,0,1,.053,1.511L1.938,14.172a1.132,1.132,0,0,1-.8.276Z",
    transform: "translate(-0.001 -2.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63170",
    "data-name": "Path 63170",
    d: "M12.259,13.838a1.132,1.132,0,0,1-.8-.333L1.8,3.742a1.158,1.158,0,0,1,.124-1.621,1.129,1.129,0,0,1,1.48,0l9.718,9.762a1.158,1.158,0,0,1,.053,1.625q-.026.028-.053.054a1.13,1.13,0,0,1-.865.276Z",
    transform: "translate(-1.484 -1.844)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconofmodal);
export default __webpack_public_path__ + "static/media/closeIconofmodal.bafbfaded33585499f099b5eb53cf04e.svg";
export { ForwardRef as ReactComponent };